// --- NEW FILE: packages/agent-kit/src/hooks/sprints/useSprints.ts ---

import useSWR from 'swr';
import { sprintService, isApiError } from '@dopomogai/api-client';
import type { Sprint } from '@dopomogai/types';
import { AgentKitError } from '../../types';

// SWR key for the public list of all sprints
const PUBLIC_SPRINTS_LIST_KEY = '/v1/sprints';

/**
 * A hook for fetching the list of all public-facing sprints.
 * Data is cached and will re-fetch on window focus by default.
 */
export const useSprintsList = () => {
  const { data, error, isLoading, mutate } = useSWR<Sprint[], AgentKitError>(
    PUBLIC_SPRINTS_LIST_KEY,
    async () => {
      // This assumes `sprintService` will have a `listSprints` method
      // that corresponds to the new GET /v1/sprints endpoint.
      const response = await sprintService.listSprints(); 
      if (isApiError(response)) {
        throw new AgentKitError('Failed to fetch public sprints list', response);
      }
      return response;
    },
    {
      // It's a good practice to prevent re-fetching on focus for lists
      // that don't change very often, to keep the UI stable.
      revalidateOnFocus: false,
    }
  );

  return {
    sprints: data,
    isLoading,
    error,
    mutate,
  };
};